var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main"},[_c('div',{ref:"header",staticClass:"header"},[_c('Header',{ref:"headerBar"}),_c('selectionlist')],1),_c('div',{staticClass:"RouteView",style:({ 'margin-top': `${_vm.mth}px` })},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }